// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Yg3uz","paper":"styles_paper__NnMVU"};